import { updateObjectState } from "../../utils/updateObjectStates"
import { registerNewUser  } from "../../services/apiService"
import { validateMobileNumber, validateEmail  } from "../../utils/validators"

export const handleUserDetailsUpdate = (key ,value, setUserDetails , setUserInputState) => {
    setUserDetails((userDetails)=>{ return {...userDetails, [`${key}`]:value}})
    if (key === 'email') {
        setUserInputState((prevState)=>{ return updateObjectState('email',value, prevState)})
    }
    if (key === 'mobileNumber') {
        setUserInputState((prevState)=>{ return updateObjectState('mobileNumber',value, prevState)})
    }
} 

export const handleUserSignUp = async (userDetails , userInputState, setUserAuth, history) => {
    if (!validateMobileNumber(userInputState.mobileNumber)) {
        return {
            error : {
                msg : 'Invalid Mobile Number'
            } ,
            status : false ,
        }
    }
    if (!validateEmail(userInputState.email)) {
        return {
            error : {
                msg : 'Invalid Email Address'
            } ,
            status : false ,
        }
    }
    let otp = userInputState.mobileOtp !== "" ? userInputState.mobileOtp : userDetails.mobileOtp
    if (otp.length !== 6) {
        return {
            error : {
                msg : 'Invalid Otp'
            } ,
            status : false ,
        }
    }
    let data = {
        gender: userDetails.gender,
        mobileOtp: otp,
        mobileNumber: userInputState.mobileNumber,
        email: userInputState.email,
        firstName: userDetails.firstName
    }

    let response = await registerNewUser(data)

    if (response.status) {
        setUserAuth({
            rydeSendToken: response.data.rydeSendToken,
            firstName: response.data.firstName,
            email: response.data.email,
            mobileNumber: response.data.mobileNumber
        })
        history.push('/new/booking')
    }
    return response
}